import { toQueryString } from '@utils/requests';

import { ITODO } from 'types/todo';

import { request } from './request';

export function load() {
  return request.get({
    url: '/job_boards/boards/',
  });
}

export function loadDetail(boardName: ITODO) {
  return request.get({
    url: `/job_boards/boards/${boardName}/`,
  });
}

export function saveDetail(boardName: ITODO, data: ITODO) {
  return request.patch({
    url: `/job_boards/boards/${boardName}/`,
    data,
  });
}

export function activateBoard(boardName: ITODO) {
  const data = { isActive: true };
  return request.patch({
    url: `/job_boards/boards/${boardName}/`,
    data,
  });
}

export function deactivateBoard(boardName: ITODO) {
  return request.delete({
    url: `/job_boards/boards/${boardName}/`,
  });
}

export function loadPostsForJob(jobId: number) {
  return request.get({
    url: '/job_boards/posts/' + toQueryString({ job: jobId }),
  });
}

export function loadPost(postId: number) {
  return request.get({
    url: `/job_boards/posts/${postId}/`,
  });
}

export function createJobPost(data: ITODO) {
  return request.post({
    url: '/job_boards/posts/',
    data,
  });
}

export function updateJobPost(postId: number, data: ITODO) {
  return request.patch({
    url: `/job_boards/posts/${postId}/`,
    data,
  });
}

export function removeJobPost(postId: number) {
  return request.delete({
    url: `/job_boards/posts/${postId}/`,
  });
}
